import { useEffect, useState } from "react";

import NewQuoteCard from "@/components/pages/client/cards/new-quote-card";
import OtherVehiclesCard from "@/components/pages/client/home/other-vehicles-card";
import ContractCard from "@/components/ui/contract-card";
import PendenciaCard from "@/components/ui/pendencia-card";
import { useAuth } from "@/contexts/auth-context";
import { getCurrentContract } from "@/services/clientAreaService";
import { CurrentContract } from "@/types/CurrentContract";

import RoofCustomersSkeleton from "@/components/pages/client/home/roof-costumer-skeleton";
import { QuoteCTASection } from "@/components/sections/section-quote-cta";
import { Separator } from "@/components/ui/separator";
import { ContractStatus } from "@/utils/status-transport";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function ResumePage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const cliCodigo = user?.cli_codigo;
  const clientName = user?.cli_fantasia || "Cliente";

  const [loading, setLoading] = useState(true);
  const [currentContracts, setCurrentContracts] = useState<CurrentContract[]>(
    [],
  );

  useEffect(() => {
    if (!cliCodigo) return;

    const fetchData = async () => {
      try {
        const contratoData = await getCurrentContract(cliCodigo);
        setCurrentContracts(contratoData || []);
      } catch {
        setCurrentContracts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [cliCodigo]);

  if (loading) return <RoofCustomersSkeleton />;

  return (
    <div className="py-6 sm:py-10 w-full max-w-7xl mx-auto">
      <h1 className="text-2xl sm:text-3xl font-bold text-n-green mb-10">
        Olá, {clientName}
      </h1>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        <div className="lg:col-span-8 flex flex-col gap-6">
          <PendenciaCard mode="home" />

          <div className="space-y-4 rounded-2xl bg-white px-5 py-4 sm:px-8 sm:py-6 shadow-sm">
            {currentContracts.length > 0 ? (
              <>
                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
                  <h2 className="text-lg font-semibold text-n-green">
                    {currentContracts.length === 1
                      ? "Seu transporte:"
                      : `Seus transportes (${currentContracts.length}):`}
                  </h2>
                </div>

                <Separator />

                <div className="space-y-4">
                  {currentContracts.map((contract) => (
                    <div key={contract.cve_codigo} className="">
                      <div className="flex justify-end">
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(
                              `/cliente/detalhes-contrato/${contract.cve_codigo}`,
                            );
                          }}
                          className="text-xs font-semibold text-n-green hover:underline flex items-center gap-1"
                        >
                          Ver detalhes
                          <ArrowRight size={14} />
                        </a>
                      </div>
                      <ContractCard
                        id={contract.ctc_codigo}
                        from={contract.mun_descricao_origem}
                        to={contract.mun_descricao_destino}
                        vehicle={contract.vmd_descricao}
                        plate={contract.cve_placa}
                        status={contract.status_situacao as ContractStatus}
                        nextStep={contract.status_situacao}
                      />
                      {currentContracts.length > 1 &&
                        contract.cve_codigo !==
                          currentContracts[currentContracts.length - 1]
                            .cve_codigo && <Separator />}
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <>
                <QuoteCTASection />
              </>
            )}
          </div>
        </div>

        <div className="lg:col-span-4 flex flex-col gap-4">
          <NewQuoteCard
            onClick={() => window.open("/fazer-cotacao", "_blank")}
          />

          <OtherVehiclesCard
            onSelect={(v) => console.log(`Selecionou: ${v}`)}
          />
        </div>
      </div>
    </div>
  );
}
